import { render } from "./ProfileSetting.vue?vue&type=template&id=5e378d86&scoped=true"
import script from "./ProfileSetting.vue?vue&type=script&lang=js"
export * from "./ProfileSetting.vue?vue&type=script&lang=js"

import "./ProfileSetting.vue?vue&type=style&index=0&id=5e378d86&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e378d86"]])

export default __exports__